import { nextTick } from "vue";
import { IContainer } from '../../../json-parse/src/interface'
import { DROP_LAYOUT_EL, DROP_CONTAINER_ACTIVE_CLASSNAME } from '../../../json-parse/src/tools/const'
import { $$dropdown, DropdownOption } from '../component/dropdown-service'
import { CreateGlobalModal } from '../component/create-global-modal'
import { parseObjToString, parseStringToObj, downloadLocalJson } from '../../../json-parse/src/tools/utils'
import UEI from '../use/useEditInfo'
import { basicLayout } from '../../../json-parse/src/tools/register'
import deepcopy from "deepcopy";

let compId = 0
// 操作容器的方法
export const containerMethods = {
  // 鼠标放下，执行添加
  targetDrop(containerEl: HTMLElement, dropedLayout: IContainer): boolean {
    if (Object.keys(dropedLayout).length === 0) {
      console.warn('拖拽元素的dropedLayout不存在！')
      return false
    }
    const containerLayout = (containerEl as any)[DROP_LAYOUT_EL]
    // dropedLayout.compId = `comp-${new Date().getTime()}-${compId++}`
    // 内部添加子元素
    containerMethods.addChildren(containerLayout, dropedLayout)
    // 修改当前激活的layout
    setTimeout(() => {
      const childrenList = containerEl.children
      const child = childrenList[childrenList.length - 1]
      if (child) {
        UEI.setClickLayout(dropedLayout)
        UEI.setClickElement(child as HTMLElement)
        if (UEI.clickElement) (UEI.clickElement as any).classList.add(DROP_CONTAINER_ACTIVE_CLASSNAME.moving)
      }
    })
    return true
  },
  // 往某一个容器中添加子容器
  addChildren(parentLayout: IContainer, child: IContainer, insertIndex = 10000): void {
    if (!Array.isArray(parentLayout.children)) parentLayout.children = []
    if (insertIndex > parentLayout.children.length) {
      // 末尾添加
      parentLayout.children.push(child)
    } else {
      // 插入元素
      parentLayout.children.splice(insertIndex, 0, child)
    }
  },
  /**
   * 在祖先中查找包含iscontainer="true"的元素（能嵌套子元素的元素）
   * @param currentParent 从自身开始查找容器类父元素
   * @param containerSelf 是否从自己开始计算
   * @returns
   */
  findUserfulContainerParent(currentParent: HTMLElement | undefined, containerSelf = true): undefined | HTMLElement {
    return containerMethods.findUserfulParent(currentParent, containerSelf, ['true', true])
  },
  /**
   * 在祖先中查找包含iscontainer属性的元素
   * 这种元素是一个最基本的操作单元，可以进行删除移动编辑等操作
   * @param currentParent 从自身开始查找容器类父元素
   * @param containerSelf 是否从自己开始计算
   * @param valueList 过滤容器的条件也就是iscontainer可能存在的值
   * @returns
   */
  findUserfulParent(currentParent: HTMLElement | undefined, containerSelf = true, valueList:(string|boolean)[]= ['true', 'false']): undefined | HTMLElement {
    const modifyDom = document.querySelector("[isroot=true]") as HTMLElement
    if (!currentParent || ['comp-canves-wrap-child'].includes(currentParent.className)) {
      // 找到了最外层画布元素，修正成子元素中的根元素包含“isroot”属性
      return modifyDom
    }
    if (!containerSelf) currentParent = (currentParent as any).parentNode
    let iscontainer = (currentParent && currentParent.getAttribute('iscontainer')) || ''
    if (valueList.includes(iscontainer)) return currentParent
    while (!valueList.includes(iscontainer)) {
      currentParent = (currentParent as any).parentNode
      if (!currentParent || currentParent === document.body) return undefined
      iscontainer = currentParent.getAttribute('iscontainer') || ''
    }
    if (!currentParent || ['comp-canves-wrap-child'].includes(currentParent.className)) {
      // 找到了最外层画布元素，修正成子元素中的根元素包含“isroot”属性
      return modifyDom
    }
    return currentParent
  },
  // 查找在父元素中的索引值
  findIndexInParent(dom: HTMLElement | undefined): undefined | { [name: string]: any } {
    if (!dom) return
    // 先查找最近的祖先元素
    let currentLayout = (dom as any)[DROP_LAYOUT_EL]
    const parentElement = containerMethods.findUserfulParent(dom, false)
    if (!parentElement) return
    const parentLayout = (parentElement as any)[DROP_LAYOUT_EL]
    // 查找索引
    const parentChild: IContainer[] = parentLayout.children || []
    let insertIndex = parentChild.findIndex(item => item === currentLayout)
    return {
      currentLayout,
      currentElement: dom,
      parentElement,
      parentLayout,
      parentChild,
      insertIndex
    }
  },
  /**
   * 删除layout布局信息
   * @param dom  真实节点
   * @returns
   */
  removeLayoutByDom(dom: HTMLElement | undefined) {
    const res = containerMethods.findIndexInParent(dom)
    if (dom && res && res?.insertIndex > -1) {
      return res.parentChild.splice(res?.insertIndex, 1)
    }
  },
  // 修改layout的前后位置
  moveLayoutLocation(dom: HTMLElement | undefined, mode: string) {
    const parent = dom?.parentNode
    // debugger
    const modeObj = {
      prev: (index:number) => index - 1, // 前进一位
      next: (index:number) => index + 1, // 后退一位
      first: (index:number) => 0, // 首位
      last: (index:number) => 10000 // 末尾
    }
    const res = containerMethods.findIndexInParent(dom)
    if (res && res.insertIndex >= 0) {
      const tempIndex = (modeObj as any)[mode](res.insertIndex)
      if (tempIndex < 0) return
      let layout = containerMethods.removeLayoutByDom(dom)
      layout && layout[0] && res.parentChild.splice(tempIndex, 0, layout[0])
      // 刷新缩放布局四周小方点
      nextTick(() => {
        let newDom: Element|undefined
        if(mode === 'prev' || mode === 'next') {
          newDom = parent?.children[tempIndex]
        } else if(mode === 'first') {
          newDom = parent?.children[0]
        } else if(mode === 'last') {
          newDom = parent?.children[parent?.children.length - 1]
        }
        UEI.setClickElement(newDom as any)
        UEI.setDotrectInfo()
      })
    }
  },
  // 前置layout布局信息
  layoutGotoNext(dom: HTMLElement | undefined) {
    const res = containerMethods.findIndexInParent(dom)
    if (res && res.insertIndex > 0) {
      let layout = containerMethods.removeLayoutByDom(dom)
      layout && layout[0] && res.parentChild.splice(res.insertIndex + 1, 0, layout[0])
    }
  },
  // 元素是否是相对定位
  elementIsRelative(tempElement: HTMLElement) {
    // if(tempElement.style.position === 'relative') return true
    // if(!['fixed', 'absolute'].includes(tempElement.style.position)) return true
    // return false
    return tempElement.style.position === 'relative' || !tempElement.style.position
  }
}

/**
 * 鼠标右键生成菜单
 * @param e 事件对象
 * @param dom 真实节点
 * @param modifyFn 通知祖先节点，跟新当前操作的节点信息
 */
export const contextmenuBlock = (event: MouseEvent) => {
  $$dropdown({
    reference: event,
    content: () => (
      <>
        <DropdownOption label="dele" title="删除布局" icon="delete-filling" {...{ onClick: quickBarMethods.deleteLayout }} />
        <DropdownOption label="eye" title="查看布局" icon="product-fill" {...{ onClick: quickBarMethods.eyeLayoutDetail }} />
        <DropdownOption label="edit" title="编辑布局" icon="edit-filling"  {...{ onClick: quickBarMethods.editLayout }} />

        <DropdownOption label="prev" title="布局前置" icon="arrow-up-filling" {...{ onClick: othersQuickMethods.prev }} />
        <DropdownOption label="next" title="布局后置" icon="arrow-down-filling" {...{ onClick: othersQuickMethods.next }} />
        <DropdownOption label="top" title="布局置顶" icon="rise-filling" {...{ onClick: othersQuickMethods.first }} />
        <DropdownOption label="tail" title="布局置尾" icon="decline-filling" {...{ onClick: othersQuickMethods.last }} />
      </>
    )
  })
}

// 右键快捷菜单独有的方法
const othersQuickMethods = {
  prev: () => {
    UEI.clickElement && containerMethods.moveLayoutLocation(UEI.clickElement, 'prev')
  },
  next: () => {
    UEI.clickElement && containerMethods.moveLayoutLocation(UEI.clickElement, 'next')
  },
  first: () => {
    UEI.clickElement && containerMethods.moveLayoutLocation(UEI.clickElement, 'first')
  },
  last: () => {
    UEI.clickElement && containerMethods.moveLayoutLocation(UEI.clickElement, 'last')
  }
}

// 通用快捷菜单的操作方法
export const quickBarMethods = {
  // 显示组件树
  showCompTree: () => {
    // ...
  },
  // 设置当前布局的父元素
  setParentLayout: () => {
    // debugger
    const clickElement = UEI.clickElement
    if(!clickElement) return undefined
    const parentElement = containerMethods.findUserfulParent(clickElement, false)
    if (!parentElement) return
    const parentLayout = (parentElement as any)[DROP_LAYOUT_EL]
    UEI.setClickElement(parentElement)
    UEI.setClickLayout(parentLayout)
  },
  // 弹出查看数据详情弹框
  eyeApidataDetail: () => {
    const jsonStr = parseObjToString(UEI.state.mockData, false)
    CreateGlobalModal({
      title: '查看节点',
      cancel: () => true,
      content: () => <textarea class="ant-input" rows={25} cols={30} v-model={jsonStr} disabled></textarea>
    })
  },
  // 弹出编辑数据弹框
  editApidata: () => {
    let jsonStr = parseObjToString(UEI.state.mockData, true)
    function change(e: any) {
      jsonStr = e.target.value
      const newObj = parseStringToObj(jsonStr)
      if(toString.call(newObj) !== '[object Object]') return
      UEI.setMockData(parseStringToObj(jsonStr))
    }
    CreateGlobalModal({
      title: '编辑数据',
      content: () => <textarea class="ant-input" rows={25} cols={30} value={jsonStr} onInput={change}></textarea>
    })
  },
  // 下载Apidata成json文件存到本地
  downloadApidataJson: () => {
    const jsonStr = parseObjToString(UEI.state.mockData, true)
    downloadLocalJson(jsonStr, 'mock')
  },
  // -----------------------------------------------------------------------------------
  // 删除节点
  deleteLayout: () => {
    if (!confirm('确定要删除这个节点吗？')) return
    UEI.clickElement && containerMethods.removeLayoutByDom(UEI.clickElement as any)
    UEI.setClickElement(undefined)
    UEI.setClickLayout(undefined)
  },
  // 弹出查看布局详情弹框
  eyeLayoutDetail: () => {
    const jsonStr = parseObjToString(UEI.state.clickLayout, false)
    CreateGlobalModal({
      title: '查看节点',
      cancel: () => true,
      content: () => <textarea class="ant-input" rows={25} cols={30} v-model={jsonStr} disabled></textarea>
    })
  },
  // 弹出编辑布局弹框
  editLayout: () => {
    let jsonStr = parseObjToString(UEI.state.clickLayout, true)
    function change(e: any) {
      jsonStr = e.target.value
      // Object.assign(UEI.state.clickLayout, parseStringToObj(jsonStr))
      const newObj = parseStringToObj(jsonStr)
      if(toString.call(newObj) !== '[object Object]') return
      UEI.setGlobalLayout(newObj as any)
    }
    CreateGlobalModal({
      title: '编辑节点',
      content: () => <textarea class="ant-input" rows={25} cols={30} value={jsonStr} onInput={change}></textarea>
    })
  },
  // 下载layout成json文件存到本地
  downloadJson: () => {
    const jsonStr = parseObjToString(UEI.state.clickLayout, true)
    downloadLocalJson(jsonStr)
  },
  // 清空画布到原始状态
  clearCanvas: () => {
    if (!confirm('确定要清空整个画布吗？')) return
    UEI.setClickElement(undefined)
    UEI.setClickLayout(undefined)
    UEI.setGlobalLayout(deepcopy(basicLayout))
    // ;(UEI.state.globalLayout as any).children = []
  },
  // 关闭画布
  closeCanvas: () => {
    // ...
  },
}
;(quickBarMethods.eyeApidataDetail as any).config = {text: 'data', title: '查看数据', icon: 'product-fill' }
;(quickBarMethods.editApidata as any).config = {text: 'data', title: '编辑数据', icon: 'edit-filling' }
;(quickBarMethods.downloadApidataJson as any).config = {text: 'data', title: '下载数据', icon: 'download' }
// ---------------------------------------------------------------------------------------------
;(quickBarMethods.setParentLayout as any).config = {text: 'father', title: '获取祖先布局', icon: 'rising' }
// -----------------------
;(quickBarMethods.deleteLayout as any).config = {text: 'layout', title: '删除节点', icon: 'delete-filling' }
;(quickBarMethods.eyeLayoutDetail as any).config = { text: 'layout',title: '查看节点', icon: 'product-fill' }
;(quickBarMethods.editLayout as any).config = { text: 'layout',title: '编辑节点', icon: 'edit-filling' }
;(quickBarMethods.downloadJson as any).config = {text: 'json', title: '下载json', icon: 'download' }
;(quickBarMethods.clearCanvas as any).config = {text: 'draw', title: '清空画布', icon: 'file-delete' }
;(quickBarMethods.closeCanvas as any).config = { text: 'draw',title: '关闭画布', icon: 'close' }
;(quickBarMethods.showCompTree as any).config = { text: 'tree',title: '显示layout树', icon: 'drag' }
